import { defineMessages } from '../../i18n/messages';

export const DemoVideoMessages = defineMessages({
  TITLE: {
    id: 'homepage.demo_video.title',
    text: 'See It in Action (90 Seconds)',
    description: 'Heading above the demo video on the homepage. Invites visitors to watch a short demo. Keep it concise and action-oriented.',
  },
  PLAY_ARIA: {
    id: 'homepage.demo_video.play_aria',
    text: 'Play the Localingos demo video',
    description: 'Screen reader label for the video play button.',
  },
  IFRAME_TITLE: {
    id: 'homepage.demo_video.iframe_title',
    text: 'Localingos Demo',
    description:
      'Accessible name of the embedded YouTube player holding the product demo. Announced by screen readers and shown by the browser if the video fails to load. "Localingos" is the product name; do not translate it.',
  },
  THUMBNAIL_ALT: {
    id: 'homepage.demo_video.thumbnail_alt',
    text: 'Localingos demo',
    description:
      'Alt text of the still frame standing in for the demo video before it is played. "Localingos" is the product name; do not translate it.',
  },
});
